import React, { useRef, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import './Planogram-page.scss';
import beverageMachinePlanogram from "../../assets/img/vicki-page/beverage-machine.png";
import sundriesMachinePlanogram from "../../assets/img/vicki-page/sundries-machine.png";
import tanningMachinePlanogram from "../../assets/img/vicki-page/tanning-machine.png";
import beverageMachinePlanogram3 from "../../assets/img/vicki-page/beverage-machine-3.0.png";
import sundriesMachinePlanogram3 from "../../assets/img/vicki-page/sundries-machine-3.0.png";
import tanningMachinePlanogram3 from "../../assets/img/vicki-page/tanning-machine-3.0.png";
import planogramVideoSrc from "../../assets/video/planogram/tanning-3.0-pog-changes.mp4";

const PLANOGRAM_SUB_TABS = [
    { id: '3-0', title: 'Planogram 3.0', link: '/planogram/3-0' },
    { id: '4-0', title: 'Planogram 4.0', link: '/planogram/4-0' },
    { id: '4-0-tanning', title: '4.0 Tanning', link: '/planogram/4-0-tanning' },
];

// ── Beverage 4.0 ──────────────────────────────────────────────────────────────
const beverageRows = [
    [
        { name: '(6) Celsius - Sparkling Wild Berry (12oz)', tray: 11, width: '1x', left: 2, right: 2 },
        { name: '(6) Celsius - Peach Mango Green Tea', tray: 12, width: '1x', left: 2, right: 2 },
        { name: '(6) Celsius - Peach Vibe (12oz)', tray: 13, width: '1x', left: 2, right: 2 },
        { name: '(6) Celsius - Tropical Vibe (12oz)', tray: 14, width: '1x', left: 2, right: 2 },
        { name: '(6) Celsius - Arctic Vibe (12oz)', tray: 15, width: '1x', left: 2, right: 2 },
        { name: '(6) Celsius Essentials - Blue Crush (16oz)', tray: 16, width: '1x', left: 2, right: 1 },
        { name: '(6) Celsius Essentials - Grape Slush (16oz)', tray: 17, width: '1x', left: 2, right: 1 },
    ],
    [
        { name: '(6) Alani Nu Cherry Slush (12oz)', tray: 21, width: '1x', left: 2, right: 1 },
        { name: '(6) Alani Nu Pink Slush (12oz)', tray: 22, width: '1x', left: 2, right: 2 },
        { name: '(6) Alani Nu Breezeberry (12oz)', tray: 23, width: '1x', left: 2, right: 2 },
        { name: '(6) Alani Strawberry Sunrise (12oz)', tray: 24, width: '1x', left: 2, right: 2 },
        { name: '(6) MM Pro Chocolate (14oz)', tray: 25, width: '1x', left: 1, right: 1 },
        { name: '(6) MM Pro Vanilla (14oz)', tray: 26, width: '1x', left: 1, right: 1 },
        { name: '(6) MM Pro Slammin Strawberry (14oz)', tray: 27, width: '1x', left: 1, right: 1 },
    ],
    [
        { name: "(10) One Bar - Hershey's Cookies n' Crème", tray: 31, width: '1x', left: 3, right: 2 },
        { name: "(10) One Bar - Reese's", tray: 32, width: '1x', left: 3, right: 2 },
        { name: '(6) MM Genuine Vanilla (Tetrapak)', tray: 33, width: '1x', left: 2, right: 2 },
        { name: '(6) MM Genuine Chocolate (Tetrapak)', tray: 34, width: '1x', left: 2, right: 2 },
        { name: '(6) Premier Protein Chocolate (Tetrapak)', tray: 35, width: '1x', left: 2, right: 2 },
        { name: '(6) Premier Protein Vanilla (Tetrapak)', tray: 36, width: '1x', left: 2, right: 2 },
        { name: '(6) Premier Protein Strawberry (Tetrapak)', tray: 37, width: '1x', left: 2, right: 2 },
    ],
    [
        { name: '(5) Gatorade Cool Blue (20oz)', tray: 41, width: '1x', left: 1, right: 1 },
        { name: '(5) Gatorade Fruit Punch (20oz)', tray: 42, width: '1x', left: 1, right: 1 },
        { name: '(5) Gatorade Lemon Lime (20oz)', tray: 43, width: '1x', left: 1, right: 1 },
        { name: '(5) Gatorade Glacier Freeze (20oz)', tray: 44, width: '1x', left: 1, right: 1 },
        { name: '(5) Gatorade Zero Orange (20oz)', tray: 45, width: '1x', left: 1, right: 1 },
        { name: '(5) Gatorade Zero Glacier Freeze (20oz)', tray: 46, width: '1x', left: 1, right: 1 },
        { name: '(6) Gatorade Zero Glacier Cherry (20oz)', tray: 47, width: '1x', left: 1, right: 1 },
    ],
    [
        { name: '(6) Aquafina (20oz)', tray: 51, width: '1x', left: 1, right: 1 },
        { name: '(6) Aquafina (20oz)', tray: 52, width: '1x', left: 1, right: 1 },
        { name: '(6) Aquafina (20oz)', tray: 53, width: '1x', left: 1, right: 1 },
        { name: '(6) Aquafina (20oz)', tray: 54, width: '1x', left: 1, right: 1 },
        { name: '(6) Aquafina (20oz)', tray: 55, width: '1x', left: 1, right: 1 },
        { name: '(6) Aquafina (20oz)', tray: 56, width: '1x', left: 1, right: 1 },
        { name: '(6) Aquafina (20oz)', tray: 57, width: '1x', left: 1, right: 1 },
    ],
];

// ── Sundries 4.0 ──────────────────────────────────────────────────────────────
const sundriesRows = [
    [
        { name: "(10) One Bar Hershey's Double Chocolate", tray: 11, width: '1x', left: 3, right: 2 },
        { name: "(10) One Bar Reese's", tray: 12, width: '1x', left: 3, right: 2 },
        { name: "(10) One Bar Hershey's Cookies n' Crème", tray: 13, width: '1x', left: 3, right: 2 },
        { name: '(10) One Bar Cinnamon Roll', tray: 14, width: '1x', left: 3, right: 2 },
        { name: '(10) Barebells Brownie Batter', tray: 15, width: '1x', left: 3, right: 2 },
        { name: '(10) Barebells Cookies & Cream', tray: 16, width: '1x', left: 3, right: 2 },
        { name: '(10) Barebells Peanut Butter & Jelly', tray: 17, width: '1x', left: 3, right: 2 },
    ],
    [
        { name: '(5) Quest Chips - Hot and Spicy', tray: 21, width: '2x', left: 1, right: 1 },
        { name: '(5) Quest Chips - Chili Lime', tray: 23, width: '2x', left: 1, right: 1 },
        { name: '(5) Quest Chips - Nacho', tray: 25, width: '2x', left: 1, right: 1 },
        { name: '(10) Legendary Pastry - Strawberry', tray: 27, width: '1x', left: 1, right: 'Remove' },
    ],
    [
        { name: '(12) L+L Cookie Chocolate Chip', tray: 31, width: '2x', left: 1, right: 1 },
        { name: '(6) L+L Cookie White Chocolate Macadamia', tray: 33, width: '2x', left: 1, right: 1 },
        { name: '(?) RX Bar - Chocolate Sea Salt', tray: 35, width: '1x', left: 3, right: 2 },
        { name: '(?) RX Bar Strawberry', tray: 36, width: '1x', left: 3, right: 2 },
        { name: '(?) RX Bar Blueberry', tray: 37, width: '1x', left: 3, right: 2 },
    ],
    [
        { name: '(10) Flex Podz', tray: 41, width: '1x', left: 'Remove', right: 'Remove' },
        { name: '(6) Skullcandy JIB', tray: 42, width: '1x', left: 1, right: 1 },
        { name: '(6) Skullcandy Dime 3', tray: 43, width: '1x', left: 'Remove', right: 1 },
        { name: '(6) Skullcandy Dime 360 PEA', tray: 44, width: '1x', left: 'Remove', right: 'Remove' },
        { name: '(6) Skull Candy Push Play Active', tray: 45, width: '2x', left: 1, right: 1 },
        { name: '(4) Resettable Lock', tray: 47, width: '1x', left: 'Remove', right: 'Remove' },
    ],
    [
        { name: '(4) PF Combo Lock', tray: 51, width: '2x', left: 'Remove', right: 1 },
        { name: '(2) Shower Towel', tray: 53, width: '2x', left: 'Remove', right: 1 },
        { name: '(6) Aquafina (20oz)', tray: 55, width: '1x', left: 1, right: 1 },
        { name: '(6) Aquafina (20oz)', tray: 56, width: '1x', left: 1, right: 1 },
        { name: '(6) Aquafina (20oz)', tray: 57, width: '1x', left: 1, right: 1 },
    ],
];

// ── Tanning 4.0 ───────────────────────────────────────────────────────────────
const tanningRows = [
    [
        { name: "(10) One Bar Hershey's Double Chocolate", tray: 11, width: '1x', left: 3, right: 2 },
        { name: "(10) One Bar Reese's", tray: 12, width: '1x', left: 3, right: 3 },
        { name: "(10) One Bar Hershey's Cookies n' Crème", tray: 13, width: '1x', left: 3, right: 3 },
        { name: '(6) One Bar Birthday Cake', tray: 14, width: '1x', left: 3, right: 2 },
        { name: '(6) Barebells Caramel Cashew', tray: 15, width: '1x', left: 2, right: 2 },
        { name: '(6) Barebells Cookies & Cream', tray: 16, width: '1x', left: 2, right: 2 },
        { name: '(10) Barebells Chocolate Dough', tray: 17, width: '1x', left: 1, right: 1 },
    ],
    [
        { name: '(6) Reef Havoc PKT', tray: 21, width: '1x', left: 2, right: 2 },
        { name: '(6) Hard Feelings PKT', tray: 22, width: '1x', left: 2, right: 2 },
        { name: '(10) Collagenetics 2-in-1 Pro PKT', tray: 23, width: '1x', left: 2, right: 1 },
        { name: '(10) Honeymoon PKT', tray: 24, width: '1x', left: 2, right: 1 },
        { name: '(10) W2B Watermelon PKT', tray: 25, width: '1x', left: 2, right: 1 },
        { name: '(10) Bel-Air Bronzed PKT', tray: 26, width: '1x', left: 2, right: 1 },
        { name: '(6) Vacay Vibes PKT', tray: 27, width: '1x', left: 3, right: 2 },
    ],
    [
        { name: '(2) Nantucket Nectar', tray: 31, width: '2x', left: 3, right: 3 },
        { name: '(4) Collagenetics 2-in-1 Pro BTL', tray: 33, width: '1x', left: 2, right: 2 },
        { name: '(3) Honeymoon BTL', tray: 34, width: '1x', left: 1, right: 2 },
        { name: '(4) W2B Watermelon BTL', tray: 35, width: '1x', left: 1, right: 1 },
        { name: '(3) Bel-Air Bronzed BTL', tray: 36, width: '1x', left: 1, right: 2 },
        { name: '(4) Vacay Vibes BTL', tray: 37, width: '1x', left: 3, right: 2 },
    ],
    [
        { name: '(4) Pacific Pearl Spray BTL', tray: 41, width: '1x', left: 3, right: 2 },
        { name: '(4) Pacific Pearl BTL', tray: 42, width: '1x', left: 'Remove', right: 1 },
        { name: '(3) W2B Wave BTL', tray: 43, width: '1x', left: 2, right: 2 },
        { name: '(4) Reef Havoc BTL', tray: 44, width: '1x', left: 3, right: 2 },
        { name: '(4) H.I.M. Jet BTL', tray: 45, width: '1x', left: 3, right: 2 },
        { name: '(4) Glocation BTL', tray: 46, width: '1x', left: 3, right: 2 },
        { name: '(8) Hard Feelings BTL', tray: 47, width: '1x', left: 1, right: 1 },
    ],
    [
        { name: '(8) Mini Coconut Krem', tray: 51, width: '1x', left: 3, right: 2 },
        { name: '(10) Mini Saltwater', tray: 52, width: '1x', left: 2, right: 1 },
        { name: '(10) Tattoo Stick', tray: 53, width: '1x', left: 2, right: 1 },
        { name: '(10) Collagenetics Illuminate Cream Concentrate BTL', tray: 54, width: '1x', left: 2, right: 1 },
        { name: '(10) Honey Gleam Cream', tray: 55, width: '1x', left: 2, right: 1 },
        { name: '(10) Soft Podz', tray: 56, width: '1x', left: 2, right: 2 },
        { name: '(8) Flex Podz', tray: 57, width: '1x', left: 2, right: 1 },
    ],
];

// ── New Sunshine ──────────────────────────────────────────────────────────────
const sunshineRows = [
    [
        { name: '(10) Protein Bar', tray: 11, width: '1x', left: 3, right: 2 },
        { name: '(10) Protein Bar', tray: 12, width: '1x', left: 3, right: 3 },
        { name: '(10) Protein Bar', tray: 13, width: '1x', left: 3, right: 3 },
        { name: '(6) Protein Bar', tray: 14, width: '1x', left: 3, right: 2 },
        { name: '(6) Protein Bar', tray: 15, width: '1x', left: 2, right: 2 },
        { name: '(6) Protein Bar', tray: 16, width: '1x', left: 2, right: 2 },
        { name: '(10) Protein Bar', tray: 17, width: '1x', left: 1, right: 1 },
    ],
    [
        { name: '(6) Jwoww Reality Check PKT', tray: 21, width: '1x', left: 2, right: 2 },
        { name: '(6) Jwoww Unstoppable PKT', tray: 22, width: '1x', left: 2, right: 2 },
        { name: '(10) Jwoww Fit PKT', tray: 23, width: '1x', left: 2, right: 1 },
        { name: '(10) 14 Karat PKT', tray: 24, width: '1x', left: 2, right: 1 },
        { name: '(10) Electric City PKT', tray: 25, width: '1x', left: 2, right: 1 },
        { name: '(10) Signature Accelerator PKT', tray: 26, width: '1x', left: 2, right: 1 },
        { name: '(6) Peptide Pro Hybrid Facial PKT', tray: 27, width: '1x', left: 3, right: 2 },
    ],
    [
        { name: '(2) JWOWW Fitspiration', tray: 31, width: '2x', left: 3, right: 3 },
        { name: '(4) Bold G', tray: 33, width: '1x', left: 2, right: 2 },
        { name: '(3) Adrenaline Rush', tray: 34, width: '1x', left: 1, right: 2 },
        { name: '(4) Nothing But Bronze Char', tray: 35, width: '1x', left: 1, right: 2 },
        { name: "(3) Life's A Beach", tray: 36, width: '1x', left: 1, right: 2 },
        { name: '(4) Sandy Beaches', tray: 37, width: '1x', left: 3, right: 2 },
    ],
    [
        { name: '(4) Cocoa Dreams Body Wash', tray: 41, width: '1x', left: 3, right: 2 },
        { name: '(4) Cocoa Dreams Tan Extender', tray: 42, width: '1x', left: 'Remove', right: 1 },
        { name: '(3) Fearlessly Bronze', tray: 43, width: '1x', left: 2, right: 2 },
        { name: '(4) Sinfully Bronze', tray: 44, width: '1x', left: 3, right: 2 },
        { name: '(4) Vibrantly Bronze', tray: 45, width: '1x', left: 3, right: 2 },
        { name: '(4) Signature Accelerator', tray: 46, width: '1x', left: 3, right: 2 },
        { name: '(8) Peptide Pro Intensifier', tray: 47, width: '1x', left: 1, right: 1 },
    ],
    [
        { name: '(8) Cocoa Dreams Tan Extender Travel', tray: 51, width: '1x', left: 3, right: 2 },
        { name: '(10) Diamond Lust', tray: 52, width: '1x', left: 2, right: 1 },
        { name: '(10) Forever After', tray: 53, width: '1x', left: 2, right: 1 },
        { name: '(10) Eye Safety', tray: 54, width: '1x', left: 2, right: 1 },
        { name: '(10) Restored Red Light', tray: 55, width: '1x', left: 2, right: 1 },
        { name: '(10) AG HOT Hybrid Spray', tray: 56, width: '1x', left: 2, right: 1 },
        { name: '(8) Peptide Pro Hybrid Facial', tray: 57, width: '1x', left: 2, right: 1 },
    ],
];

// ── New Sunshine POG Product List ────────────────────────────────────────────
const POG_HEADERS = ['Position', 'Facing', 'SKU #', 'Product Description', 'Vendor', 'Shelf QTY', 'Rec. Initial Order QTY', 'Unit Cost', 'Retail Price'];

const sunshinePogProducts = [
    { pos: 11, facing: 1, sku: '221047',  desc: "One Bar Hershey's Double Chocolate",  vendor: 'Muscle Foods', shelf: 10, recOrder: '36 (3 cases)', cost: '$2.13', retail: '$3.25' },
    { pos: 12, facing: 1, sku: '0221048', desc: "One Bar Reese's",                      vendor: 'Muscle Foods', shelf: 10, recOrder: '36 (3 cases)', cost: '$2.13', retail: '$3.25' },
    { pos: 13, facing: 1, sku: '0221049', desc: "One Bar Hershey's Cookies n' Crème",   vendor: 'Muscle Foods', shelf: 10, recOrder: '36 (3 cases)', cost: '$2.13', retail: '$3.25' },
    { pos: 14, facing: 1, sku: '221057',  desc: 'One Bar Birthday Cake',                vendor: 'Muscle Foods', shelf: 10, recOrder: '36 (3 cases)', cost: '$2.13', retail: '$3.25' },
    { pos: 15, facing: 1, sku: '6360002', desc: 'Barebells Caramel Cashew Bar',         vendor: 'Muscle Foods', shelf: 10, recOrder: '36 (3 cases)', cost: '$2.23', retail: '$3.25' },
    { pos: 16, facing: 1, sku: '6360003', desc: "Barebells Cookies n' Crème Bar",       vendor: 'Muscle Foods', shelf: 10, recOrder: '36 (3 cases)', cost: '$2.23', retail: '$3.25' },
    { pos: 17, facing: 1, sku: '6360007', desc: 'Barebells Chocolate Dough',            vendor: 'Muscle Foods', shelf: 10, recOrder: '36 (3 cases)', cost: '$2.23', retail: '$3.25' },
    { pos: 21, facing: 1, sku: 'W00285',  desc: 'JWOWW Reality Check (pkt)',            vendor: 'New Sunshine', shelf: 10, recOrder: '12',           cost: '$4.12', retail: '$8.25' },
    { pos: 22, facing: 1, sku: 'W00936',  desc: 'JWOWW Unstoppable (pkt)',              vendor: 'New Sunshine', shelf: 10, recOrder: '23',           cost: '$3.87', retail: '$7.75' },
    { pos: 23, facing: 1, sku: 'W00310',  desc: 'JWOWW Fit (pkt)',                      vendor: 'New Sunshine', shelf: 10, recOrder: '12',           cost: '$6.01', retail: '$12.00' },
    { pos: 24, facing: 1, sku: 'DS1137',  desc: '14 Karat (pkt)',                       vendor: 'New Sunshine', shelf: 10, recOrder: '12',           cost: '$6.62', retail: '$13.20' },
    { pos: 25, facing: 1, sku: 'A10697',  desc: 'Electric City (pkt)',                  vendor: 'New Sunshine', shelf: 10, recOrder: '12',           cost: '$7.88', retail: '$15.75' },
    { pos: 26, facing: 1, sku: 'A10694',  desc: 'Signature Accelerator (pkt)',          vendor: 'New Sunshine', shelf: 10, recOrder: '12',           cost: '$2.13', retail: '$4.25' },
    { pos: 27, facing: 1, sku: 'A10673',  desc: 'Peptide Pro Hybrid Facial (pkt)',      vendor: 'New Sunshine', shelf: 10, recOrder: '12',           cost: '$2.13', retail: '$4.25' },
    { pos: 31, facing: 2, sku: 'W00344',  desc: 'JWOWW Fitspiration',                  vendor: 'New Sunshine', shelf: 6,  recOrder: '6',            cost: '$39.50', retail: '$79.00' },
    { pos: 33, facing: 1, sku: 'A00578',  desc: 'Bold G',                               vendor: 'New Sunshine', shelf: 3,  recOrder: '3',            cost: '$31.50', retail: '$63.00' },
    { pos: 34, facing: 1, sku: 'A005695', desc: 'Adrenaline Rush',                     vendor: 'New Sunshine', shelf: 3,  recOrder: '3',            cost: '$25.00', retail: '$50.00' },
    { pos: 35, facing: 1, sku: 'A00539',  desc: 'Nothing But Bronze Char',             vendor: 'New Sunshine', shelf: 4,  recOrder: '4',            cost: '$24.50', retail: '$49.00' },
    { pos: 36, facing: 1, sku: 'A00553',  desc: "Life's A Beach",                      vendor: 'New Sunshine', shelf: 3,  recOrder: '3',            cost: '$23.38', retail: '$46.75' },
    { pos: 37, facing: 1, sku: 'A00544',  desc: 'Sandy Beaches',                       vendor: 'New Sunshine', shelf: 6,  recOrder: '6',            cost: '$21.26', retail: '$42.50' },
    { pos: 41, facing: 1, sku: 'A00543',  desc: 'Cocoa Dreams Body Wash',              vendor: 'New Sunshine', shelf: 4,  recOrder: '4',            cost: '$11.85', retail: '$19.75' },
    { pos: 42, facing: 1, sku: 'A00530',  desc: 'Cocoa Dreams Tan Extender',           vendor: 'New Sunshine', shelf: 4,  recOrder: '4',            cost: '$16.50', retail: '$24.00' },
    { pos: 43, facing: 1, sku: 'A00527',  desc: 'Fearlessly Bronze',                   vendor: 'New Sunshine', shelf: 4,  recOrder: '4',            cost: '$18.60', retail: '$37.25' },
    { pos: 44, facing: 1, sku: 'A00537',  desc: 'Sinfully Bronze',                     vendor: 'New Sunshine', shelf: 4,  recOrder: '4',            cost: '$14.51', retail: '$29.00' },
    { pos: 45, facing: 1, sku: 'A00552',  desc: 'Vibrantly Bronze',                    vendor: 'New Sunshine', shelf: 4,  recOrder: '4',            cost: '$15.75', retail: '$31.50' },
    { pos: 46, facing: 1, sku: 'A00694',  desc: 'Signature Accelerator',               vendor: 'New Sunshine', shelf: 4,  recOrder: '4',            cost: '$13.75', retail: '$27.50' },
    { pos: 47, facing: 1, sku: 'A00548',  desc: 'Peptide Pro Intensifier',             vendor: 'New Sunshine', shelf: 4,  recOrder: '4',            cost: '$18.75', retail: '$37.50' },
    { pos: 51, facing: 1, sku: 'A00541',  desc: 'Cocoa Dreams Tan Extender Travel',    vendor: 'New Sunshine', shelf: 8,  recOrder: '8',            cost: '$4.48',  retail: '$6.99' },
    { pos: 52, facing: 1, sku: 'DS0235',  desc: 'Diamond Lust',                        vendor: 'New Sunshine', shelf: 8,  recOrder: '8',            cost: '$28.00', retail: '$56.00' },
    { pos: 53, facing: 1, sku: 'A00542',  desc: 'Forever After Tan Travel',            vendor: 'New Sunshine', shelf: 8,  recOrder: '8',            cost: '$4.48',  retail: '$6.99' },
    { pos: 54, facing: 1, sku: '—',       desc: 'Eye Safety',                          vendor: 'New Sunshine', shelf: 6,  recOrder: '6',            cost: '$5.30',  retail: '$10.58' },
    { pos: 55, facing: 1, sku: 'CT0154',  desc: 'Restored Target Serum',               vendor: 'New Sunshine', shelf: 3,  recOrder: '3',            cost: '$27.25', retail: '$54.50' },
    { pos: 56, facing: 1, sku: 'A00691',  desc: 'HOT Hybrid Prep Spray',               vendor: 'New Sunshine', shelf: 8,  recOrder: '24',           cost: '$17.50', retail: '$35.00' },
    { pos: 57, facing: 1, sku: 'A00673',  desc: 'Peptide Pro Hybrid Facial',           vendor: 'New Sunshine', shelf: 10, recOrder: '24',           cost: '$13.50', retail: '$27.00' },
];

function ProductListTable({ title, products, headers }) {
    const tableRef = useRef(null);
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        const rows = [headers, ...products.map(p => Object.values(p))];
        const tsv = rows.map(r => r.join('\t')).join('\n');
        navigator.clipboard.writeText(tsv).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    return (
        <div className="pog-product-list-wrapper">
            <div className="pog-product-list-header">
                <h3 className="pog-table-title" style={{ margin: 0 }}>{title}</h3>
                <button className="pog-copy-btn" onClick={handleCopy}>
                    {copied ? '✓ Copied!' : 'Copy Table'}
                </button>
            </div>
            <div className="pog-product-list-scroll">
                <table className="pog-product-list-table" ref={tableRef}>
                    <thead>
                        <tr>{headers.map(h => <th key={h}>{h}</th>)}</tr>
                    </thead>
                    <tbody>
                        {products.map((p, i) => (
                            <tr key={i}>
                                <td>{p.pos}</td>
                                <td>{p.facing}</td>
                                <td>{p.sku}</td>
                                <td className="pog-desc-cell">{p.desc}</td>
                                <td>{p.vendor}</td>
                                <td>{p.shelf}</td>
                                <td>{p.recOrder}</td>
                                <td>{p.cost}</td>
                                <td>{p.retail}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

function PlanogramCell({ item }) {
    const flex = item.width === '2x' ? 2 : 1;
    return (
        <div className={`pog-cell${item.highlight ? ' pog-cell--highlight' : ''}`} style={{ flex }}>
            <div className="pog-cell-name">{item.name}</div>
            <div className="pog-cell-detail">Tray #: {item.tray}</div>
            <div className="pog-cell-detail">Tray Width: {item.width}</div>
            <div className="pog-cell-detail">Left Wall Position: {item.left}</div>
            <div className="pog-cell-detail">Right Wall Position: {item.right}</div>
        </div>
    );
}

function PlanogramTable({ title, rows }) {
    return (
        <div className="pog-table-wrapper">
            <h3 className="pog-table-title">{title}</h3>
            <div className="pog-table">
                {rows.map((row, ri) => (
                    <div key={ri} className="pog-row">
                        {row.map((cell, ci) => (
                            <PlanogramCell key={ci} item={cell} />
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}

function PlanogramPage() {
    const { pathname } = useLocation();
    const is20 = pathname.endsWith('/2-0') || pathname === '/planogram';
    const is30 = pathname.endsWith('/3-0');
    const is40 = pathname.endsWith('/4-0');
    const is40tanning = pathname.endsWith('/4-0-tanning');

    return (
        <div className={'planogram-page-wrapper'}>
            <nav className={'planogram-sub-tabs'}>
                <ul>
                    {PLANOGRAM_SUB_TABS.map(tab => (
                        <li key={tab.id}>
                            <NavLink to={tab.link}>{tab.title}</NavLink>
                        </li>
                    ))}
                </ul>
            </nav>

            {is20 && (
                <section className={'section'}>
                    <h3 className={'section-sub-title'}>Beverage Machine (Planogram 2.0)</h3>
                    <div className={'planogram-photo-wrapper'}><img src={beverageMachinePlanogram} alt={'Beverage Machine'} /></div>
                    <h3 className={'section-sub-title mt-50'}>Sundries Machine (Planogram 2.0)</h3>
                    <div className={'planogram-photo-wrapper'}><img src={sundriesMachinePlanogram} alt={'Sundries Machine'} /></div>
                    <h3 className={'section-sub-title mt-50'}>Tanning Machine (Planogram 2.0)</h3>
                    <div className={'planogram-photo-wrapper'}><img src={tanningMachinePlanogram} alt={'Tanning Machine'} /></div>
                </section>
            )}

            {is30 && (
                <>
                    <section className={'section'}>
                        <h3 className={'section-sub-title'}>Beverage Planogram (Planogram 3.0)</h3>
                        <div className={'planogram-photo-wrapper'}><img src={beverageMachinePlanogram3} alt={'Beverage Planogram 3.0'} /></div>
                        <h3 className={'section-sub-title mt-50'}>Sundries Planogram (Planogram 3.0)</h3>
                        <div className={'planogram-photo-wrapper'}><img src={sundriesMachinePlanogram3} alt={'Sundries Planogram 3.0'} /></div>
                        <h3 className={'section-sub-title mt-50'}>Tanning Planogram (Planogram 3.0)</h3>
                        <div className={'planogram-photo-wrapper'}><img src={tanningMachinePlanogram3} alt={'Tanning Planogram 3.0'} /></div>
                        <hr className={'divider'}/>
                    </section>
                    <section className={'section'}>
                        <div className={'body-text text-left d-flex flex-column'}>
                            <p>Are you ready to make your changes from your current planogram to planogram 3.0?</p>
                            <p>Keep in mind each machine will need to be updated as whole, this allows for any shelf adjustments needed.</p>
                            <ol className={'steps-list'}>
                                <li>Order all new product and make sure you have received at the club</li>
                                <li>Sell out of retiring products or ensure it has been removed from the machine</li>
                                <li>For tanning machine updates please watch the attached video ahead of reaching & make necessary adjustments as seen in the video</li>
                                <li>
                                    Reach out to{' '}
                                    <a href="mailto:vickipfsupport@viatouchmedia.com">vickipfsupport@viatouchmedia.com</a>
                                    <ul className={'sublist'}>
                                        <li>a. Be sure to include which machine you will be updating{' & '}your location</li>
                                    </ul>
                                </li>
                                <li>Calibrate updated spots</li>
                                <li>You are ready to go!</li>
                            </ol>
                        </div>
                        <video className={'planogram-video'} controls>
                            <source src={planogramVideoSrc} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </section>
                </>
            )}

            {is40 && (
                <section className={'section'}>
                    <PlanogramTable title="Beverage Planogram (Planogram 4.0)" rows={beverageRows} />
                    <PlanogramTable title="Sundries Planogram (Planogram 4.0)" rows={sundriesRows} />
                </section>
            )}

            {is40tanning && (
                <section className={'section'}>
                    <PlanogramTable title="4.0 Tanning Option 1 - Devoted Creations" rows={tanningRows} />
                    <PlanogramTable title="4.0 Tanning Option 2 - New Sunshine" rows={sunshineRows} />
                    <ProductListTable
                        title="New Sunshine POG Product List"
                        products={sunshinePogProducts}
                        headers={POG_HEADERS}
                    />
                </section>
            )}
        </div>
    );
}

export default PlanogramPage;
